import { useReveal } from "../hooks/useReveal";
import { TRANSFORMS } from "../lib/copy";

export default function Transformation() {
  const ref = useReveal();
  return (
    <section ref={ref} className="py-28 md:py-36" data-testid="transformation-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16">
        <div>
          <p className="section-label mb-8 reveal-up">[006] — SOUND FAMILIAR?</p>
          <h2 className="reveal-up font-black uppercase mb-8" style={{ fontSize: "clamp(26px, 3vw, 40px)", letterSpacing: "-0.02em", lineHeight: 1.1 }}>
            IF YOU'RE LIKE MOST VA BUYERS I WORK WITH...
          </h2>
          <div className="space-y-5 reveal-up" style={{ color: "rgba(240,236,228,0.6)", lineHeight: 1.8, fontSize: 15 }} data-testid="pain-paragraphs">
            <p>
              Maybe you've searched online, talked with a lender or tried a mortgage calculator—and you're still not completely sure what buying a home with your VA benefit would actually look like. How much could you comfortably afford? How much cash might you need? What would the monthly payment look like? And how does your VA entitlement affect the equation?
            </p>
            <p>
              Those questions deserve more than a generic calculator or a one-size-fits-all answer. VA financing has details that can materially affect your buying strategy, and understanding them before you're under contract can help you make better decisions when the right home comes along.
            </p>
          </div>
        </div>
        <div className="lg:pt-24">
          <p className="mono reveal-up mb-8" style={{ fontSize: 12, letterSpacing: "0.22em", color: "#FFFFFF" }}>
            HERE'S WHAT CHANGES AFTER THIS WEBINAR:
          </p>
          <ul className="space-y-6 mb-12">
            {TRANSFORMS.map((t, i) => (
              <li key={i} className="reveal-up flex gap-4 items-start" data-testid={`transform-bullet-${i + 1}`}>
                <span style={{ color: "#3D7BFF", fontWeight: 800, fontSize: 18 }}>→</span>
                <span style={{ color: "rgba(240,236,228,0.8)", lineHeight: 1.7, fontSize: 15 }}>{t}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
